import {GET_LEGAL_ACTION_INFO_REQUEST, 
    GET_LEGAL_ACTION_INFO_SUCCESS, 
    GET_LEGAL_ACTION_INFO_ERROR} from '../actions/type';

const initialState = {
    loading: null,
    error: null,
    data: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state=initialState, action) => {
    switch(action.type) {
        case GET_LEGAL_ACTION_INFO_REQUEST:
            return {
                ...state,
                loading: true
            }
        case GET_LEGAL_ACTION_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data
            }
        case GET_LEGAL_ACTION_INFO_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        default:
            return state;
    }
}